/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { LogoMultiCardFragment } from "@cosmos/hygraph-schema";

import { css, cx } from "@panda/css";
import { Grid } from "@panda/jsx";
import { ColorToken } from "@panda/tokens";
import { LogoCard } from "./LogoCard.molecule";

const gridStyles = css({
	flexGrow: "1",
	flexBasis: "0",
	mdDown: { gridTemplateColumns: "1fr", alignSelf: "stretch" },
});

const Layout_2cards = css({
	gridTemplateColumns: "repeat(2, minmax(360px, 1fr))",
});

const Layout_3cards = css({
	gridTemplateColumns: "repeat(3, minmax(280px, 1fr))",
});

export type LogoMultiCardsProps = {
	cards: LogoMultiCardFragment[];
	descriptionColor?: ColorToken;
};

export function LogoMultiCards({ cards, descriptionColor }: LogoMultiCardsProps): React.JSX.Element {
	return (
		<Grid
			gap="eds.dimension.16"
			className={cx("logo-multi-cards", gridStyles, cards.length === 2 ? Layout_2cards : Layout_3cards)}
		>
			{cards.map((card, i) => (
				<LogoCard key={`logo-card-${i}`} {...card} descriptionColor={descriptionColor} />
			))}
		</Grid>
	);
}
